import { organizationStore } from "../organizationStore"

export const useOrganizationStore = () => {
  const orgs = organizationStore((state) => state.orgs)
  const loadingOrgs = organizationStore((state) => state.loadingOrgs)
  const orgsError = organizationStore((state) => state.orgsError)
  const selectedOrgId = organizationStore((state) => state.selectedOrgId)
  const sites = organizationStore((state) => state.sites)
  const loadingSites = organizationStore((state) => state.loadingSites)
  const sitesError = organizationStore((state) => state.sitesError)

  const getOrganizations = organizationStore((state) => state.getOrganizations)
  const getSitesByOrganization = organizationStore(
    (state) => state.getSitesByOrganization,
  )
  const setSelectedOrgId = organizationStore((state) => state.setSelectedOrgId)
  const clearOrgs = organizationStore((state) => state.clearOrgs)
  const getSiteNamesByIds = organizationStore(
    (state) => state.getSiteNamesByIds,
  )

  return {
    orgs,
    loadingOrgs,
    orgsError,
    selectedOrgId,
    sites,
    loadingSites,
    sitesError,
    getOrganizations,
    getSitesByOrganization,
    getSiteNamesByIds,
    setSelectedOrgId,
    clearOrgs,
  }
}

export default useOrganizationStore
